export default {
    layoutLimits: {
        minWidth: 250,
        minHeight: 50
    }
}
